import {
    ChildEventEnum,
    childEventRemovePrefix,
    ChildLoginEventData,
    ParentMsg
} from "@/utils/IFrameUtil";
import GlxAiChatPluginEventUtil from "@/utils/GlxAiChatPluginEventUtil";

export type UseIFrameMessageParams = {
    onLogin: (data: ChildLoginEventData) => void,
    // onClose: () => void
}

export default function useIFrameMessage(
    {

        onLogin = data => {
        },
        // onClose = () => {
        // }
    }: UseIFrameMessageParams
) {
    window.addEventListener("message", function (event: MessageEvent<ParentMsg>) {
        const eventData = event.data;

        if (!eventData.event || !eventData.data) {
            return;
        }

        const glxData = eventData.data
        const glxEvent = childEventRemovePrefix(eventData.event)

        console.log(`parent接收到消息[${glxEvent}]:`)
        console.table(`收到的数据：${JSON.stringify(glxData)}`)

        // console.log(`收到来自parent的消息：event:${glxEvent},msg:${JSON.stringify(eventData.data)}`);

        if (glxEvent === ChildEventEnum.login) {

            const innerGlxData = glxData as ChildLoginEventData;

            onLogin(innerGlxData)
        } else if (glxEvent === ChildEventEnum.close) {
            // onClose()
        }
        // else if (glxEvent === ParentEventEnum.login) {
        //
        //     // 接收到 aiShop 的登录事件，说明这个插件是 aiShop 引用的
        //     const innerGlxData = glxData as ParentLoginEventData;
        //
        //     onLogin(innerGlxData)
        // }
    });
}